import { render } from "./AppError404.vue?vue&type=template&id=7b9fb4b4&scoped=true"
import script from "./AppError404.vue?vue&type=script&lang=js"
export * from "./AppError404.vue?vue&type=script&lang=js"

import "./AppError404.vue?vue&type=style&index=0&id=7b9fb4b4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9fb4b4"]])

export default __exports__